import { setCookie } from 'bv';

const TEN_YEARS_MILLIS = 10 * 365 * 24 * 3600 * 1000;

export const acceptCookiesPolicy = () => {
  setCookie('accepted_cookies_policy', true, '/', TEN_YEARS_MILLIS);
};
